import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/** Возвращает коофициент, влияющий на то, насколько большая зона будет во втором(четном) запросе за пинами. */
export var getFetchRatio = function getFetchRatio(options) {
  return options.fetchCoefficient * (options.currentZoom / options.minZoom);
};

/** Возвращает данные необходимые клиенту для запроса за данными для большой зоны(вторые или четные запросы) */
export var getDataForHugeFetch = function getDataForHugeFetch(options) {
  var fetchCoefficient = options.fetchCoefficient,
    data = options.data,
    minZoom = options.minZoom,
    geoObjectNames = options.geoObjectNames;
  var zoom = data.zoom,
    center = data.center;
  var bbox = data.bbox;
  var fetchRatio = getFetchRatio({
    fetchCoefficient: fetchCoefficient,
    currentZoom: zoom,
    minZoom: minZoom
  });
  var bboxWidth = bbox.topLeft.lng - bbox.bottomRight.lng;
  var bboxMultipliedWidth = bboxWidth * fetchRatio;
  var bboxHeight = bbox.bottomRight.lat - bbox.topLeft.lat;
  var bboxMultipliedHeight = bboxHeight * fetchRatio;
  bbox = {
    topLeft: {
      lng: bbox.topLeft.lng + bboxMultipliedWidth,
      lat: bbox.topLeft.lat - bboxMultipliedHeight
    },
    bottomRight: {
      lng: bbox.bottomRight.lng - bboxMultipliedWidth,
      lat: bbox.bottomRight.lat - bboxMultipliedHeight
    }
  };
  return {
    zoom: zoom,
    bbox: bbox,
    center: center,
    geoObjectNames: geoObjectNames
  };
};

/** Возвращает данные необходимые клиенту для запроса за данными */
export var getFetchData = function getFetchData(options) {
  return _objectSpread(_objectSpread({}, options.data), {}, {
    geoObjectNames: options.geoObjectNames
  });
};